// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"PresentationView_Wrapper__3-zBn","Image":"PresentationView_Image__3ftsG","Text":"PresentationView_Text__2Zdbx"};